module.exports = __webpack_public_path__ + "static/bulk-order-f043715db13181dda74532168003ca94.png";